export default {
  init() {
    $('h2.entry-title a').each(function(){
         var me = $(this);
         me.html(me.html().replace(/^(\w+)/, '<span>$1</span>'));
    });

    // JavaScript to be fired on the about us page
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/blog.js